var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initAddToCartButton = /* @__PURE__ */ __name(($el, variantId) => {
  const state = window.Alpine.reactive({
    element: $el,
    isAdding: false
  });
  const handleAddToCart = /* @__PURE__ */ __name(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    state.isAdding = true;
    const data = await _cart.add({
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]
    });
    state.isAdding = false;
    if (!data.cart_error) {
      _stores.modal.setId("cart-drawer");
      _stores.productDrawer.open = false;
      _stores.quickView.open = false;
    }
  }, "handleAddToCart");
  return {
    state,
    handleAddToCart
  };
}, "initAddToCartButton");
window._sections["initAddToCartButton"] = initAddToCartButton;
